export abstract class BaseAuthService<TUser, TClient> {
  public abstract user: () => TUser | null | Promise<TUser | null>

  protected authClient: TClient

  protected constructor(authClient: TClient) {
    this.authClient = authClient
  }

  /**
   * Initialize the authentication service.
   */
  abstract init(): Promise<void>

  /**
   * Check if the user is authenticated.
   *
   * @returns true if the user is authenticated.
   */
  abstract isAuthenticated(): Promise<boolean>

  /**
   * Get the access token from the service.
   *
   * @returns The access token or null if not found.
   */
  abstract getAccessToken(): Promise<string | null>

  /**
   * Logout the user from the service. And remove the token from the storage.
   *
   * @returns true if the user is logged out.
   */
  abstract logout(): Promise<boolean>
}
